import apiClient from '@/lib/api';
import type { AuditEntry } from '@/types';

export interface AuditListParams {
  period?: string;
  entityId?: string;
  page?: number;
  pageSize?: number;
}

export interface AuditListResponse {
  data: AuditEntry[];
  total: number;
  page: number;
  pageSize: number;
}

export async function listAuditEntries(params: AuditListParams = {}): Promise<AuditListResponse> {
  const { data } = await apiClient.get('/audit', { params });
  if (Array.isArray(data.data)) {
    return {
      data: data.data,
      total: data.total ?? data.data.length,
      page: data.page ?? 1,
      pageSize: data.pageSize ?? 50,
    };
  }
  return data;
}

export async function exportAuditCsv(period: string): Promise<Blob> {
  const response = await apiClient.get('/audit/export', {
    params: { period },
    responseType: 'blob',
  });
  return response.data as Blob;
}
